import * as Yup from 'yup';
import { MESSAGE_INVALID_CARD_CODE, MESSAGE_REQUIRED, cardCodeRegExp } from '@/utils/validation-utils';

export const cardCodeSchema: Yup.StringSchema = Yup.string()
  .required(MESSAGE_REQUIRED)
  .matches(cardCodeRegExp, MESSAGE_INVALID_CARD_CODE);
